import { render, staticRenderFns } from "./AwardsSTEM.vue?vue&type=template&id=208519e5&scoped=true&"
import script from "./AwardsSTEM.vue?vue&type=script&lang=js&"
export * from "./AwardsSTEM.vue?vue&type=script&lang=js&"
import style0 from "./AwardsSTEM.vue?vue&type=style&index=0&id=208519e5&lang=less&scoped=true&"
import style1 from "./AwardsSTEM.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208519e5",
  null
  
)

export default component.exports